import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { catalogQueryOptions } from '@/features/catalog/queries';
import { groupCatalog } from '@/lib/catalogMap';
import { SEARCH_CATALOG_SCHEMA, searchCatalog, type SearchCatalogArgs } from '@/lib/webmcp';

// WebMCP: expose AnyAPI's catalog to in-browser AI agents via the proposed
// navigator.modelContext API. Registers one unauthenticated tool, search_catalog,
// so an agent on the page can discover APIs (with USD pricing) before signing up.
// Renders nothing; registration runs client-side only (navigator is browser-only).
interface WebMcpTool {
  name: string;
  description: string;
  inputSchema: object;
  execute: (args: unknown) => Promise<{ content: { type: string; text: string }[] }>;
}
interface ModelContext {
  provideContext?: (ctx: { tools: WebMcpTool[] }) => void;
}

export function WebMcp() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const mc = (navigator as Navigator & { modelContext?: ModelContext }).modelContext;
    if (!mc?.provideContext) return;
    mc.provideContext({
      tools: [
        {
          name: 'search_catalog',
          description:
            'Search the AnyAPI catalog of scraping and data APIs by keyword or category. Returns matching APIs with USD pricing. AnyAPI gives agents one key and one USD wallet to call hundreds of providers through a single normalized interface.',
          inputSchema: SEARCH_CATALOG_SCHEMA,
          execute: async (args) => {
            const entries = await queryClient.fetchQuery(catalogQueryOptions());
            const apis = groupCatalog(entries);
            return searchCatalog(apis, (args ?? {}) as SearchCatalogArgs);
          },
        },
      ],
    });
  }, [queryClient]);

  return null;
}
